import { userTempPasswordCreateApi } from "src/domain/api/user/userTempPasswordCreateApi"

export interface IUserTempPasswordCreateResponse {
	tempPassword: string
	tempPasswordExpiresAt: number
	tempPasswordCreatedAt?: number
}

export async function userTempPasswordCreateService(
	token: string | null,
): Promise<IUserTempPasswordCreateResponse> {
	const response = await userTempPasswordCreateApi(token)
	return {
		tempPassword: response.tempPassword,
		tempPasswordExpiresAt: response.tempPasswordExpiresAt,
		tempPasswordCreatedAt: response.tempPasswordCreatedAt,
	}
}
